var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-query-view-mode clearfix" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "small-6 medium-6 large-6" },
          [
            _c("label", { staticClass: "emphasis" }, [
              _vm._v(_vm._s(_vm.$t("tender.query.closingTime")) + ":"),
            ]),
            _vm._v(" "),
            _c("date-time-selector", {
              attrs: {
                date: _vm.query.closingDate,
                timeOptions: _vm.timeOptions,
                disabled: true,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isContractor && _vm.issuedTime,
                expression: "!isContractor && issuedTime",
              },
            ],
            staticClass: "small-3 medium-3 large-3",
          },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("tender.query.issuedTime")) + ":"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "submitted-time" }, [
              _vm._v(_vm._s(_vm.issuedTime)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.submittedTime,
                expression: "submittedTime",
              },
            ],
          },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("tender.query.submittedBy")) + ":"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "submitted-time" }, [
              _vm._v(
                _vm._s(_vm.submitterName) + " on " + _vm._s(_vm.submittedTime)
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("question", { attrs: { readonly: true, query: _vm.query } }),
      _vm._v(" "),
      _c("div", { staticClass: "query-attachments" }, [
        _vm.engineerFiles.length
          ? _c(
              "div",
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("tender.tenderAttachment"))),
                ]),
                _vm._v(" "),
                _c("attachments", {
                  attrs: {
                    noHighlight: true,
                    editView: false,
                    files: _vm.engineerFiles,
                    zipName: _vm.zipPrefix + "_Attachments.zip",
                  },
                  on: {
                    "update:files": function ($event) {
                      _vm.engineerFiles = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.vendorFiles.length
          ? _c(
              "div",
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("vendor.attachment.vendor"))),
                ]),
                _vm._v(" "),
                _c("attachments", {
                  attrs: {
                    noHighlight: true,
                    editView: false,
                    files: _vm.vendorFiles,
                    zipName: _vm.zipPrefix + "_Vendor_Attachments.zip",
                  },
                  on: {
                    "update:files": function ($event) {
                      _vm.vendorFiles = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row action-btns align-right" }, [
        _vm.withEditBtn
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "note",
                    rawName: "v-note",
                    value: { text: _vm.noteText, enable: !_vm.editable },
                    expression: "{text:noteText, enable: !editable}",
                  },
                ],
                staticClass: "btn btn--darkblue",
                attrs: { disabled: !_vm.editable },
                on: {
                  click: function ($event) {
                    return _vm.edit()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.edit")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isDraft && _vm.isPicView
          ? _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { disabled: !_vm.editable },
                on: {
                  click: function ($event) {
                    return _vm.edit(true)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("action.issue")) +
                    " " +
                    _vm._s(_vm.$t("tender.query.name"))
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }